import { PropostaVersaoParcelas } from 'models/PropostaVersaoParcelas';
import { iPropostaDados } from '../../../..';

interface ParcelaInput {
  id: number;
  meioPagId: number;
  descricao: string;
  percentual: number;
  valorCentavos: number;
  observacao: string;
}

export default function gerarParcelasDefault(
  propostaVersao: iPropostaDados,
  meioPagamentoId: number,
): any[] {
  if (!meioPagamentoId) return [];

  const valFinalCentavos = Math.round(
    propostaVersao.valores.valorFinalParcelas * 100,
  );

  const { propostaVersaoId } = propostaVersao;

  const percentual20 = 20;
  const percentual30 = 30;
  const percentual40 = 40;
  const percentual70 = 70;

  const parcelas = [];

  function criarParcela({
    id,
    meioPagId,
    descricao,
    percentual,
    valorCentavos,
    observacao,
  }: ParcelaInput) {
    return {
      id,
      propostaVersaoId,
      meioPagamentoId: meioPagId,
      meioPagamento: { descricao },
      dataPrevista: null,
      percentual,
      valor: valorCentavos / 100,
      observacao,
    };
  }

  if (meioPagamentoId === 1) {
    const valor40p1 = Math.round((valFinalCentavos * percentual40) / 100);
    const valor40p2 = Math.round((valFinalCentavos * percentual40) / 100);
    const valor20 = valFinalCentavos - (valor40p1 + valor40p2);

    parcelas.push(
      criarParcela({
        id: 0,
        meioPagId: meioPagamentoId,
        descricao: 'Recurso Próprio',
        percentual: 40,
        valorCentavos: valor40p1,
        observacao: '',
      }),
      criarParcela({
        id: 1,
        meioPagId: meioPagamentoId,
        descricao: 'Recurso Próprio',
        percentual: 40,
        valorCentavos: valor40p2,
        observacao: '',
      }),
      criarParcela({
        id: 2,
        meioPagId: meioPagamentoId,
        descricao: 'Recurso Próprio',
        percentual: 20,
        valorCentavos: valor20,
        observacao: '',
      }),
    );
  } else if (meioPagamentoId === 2) {
    const valor70 = Math.round((valFinalCentavos * percentual70) / 100);
    const valor30 = valFinalCentavos - valor70;

    parcelas.push(
      criarParcela({
        id: 0,
        meioPagId: meioPagamentoId,
        descricao: 'Financiamento',
        percentual: 70,
        valorCentavos: valor70,
        observacao: 'Compra de Materiais e Início de Montagem',
      }),
      criarParcela({
        id: 1,
        meioPagId: meioPagamentoId,
        descricao: 'Financiamento',
        percentual: 30,
        valorCentavos: valor30,
        observacao: 'Entrega do Equipamento',
      }),
    );
  } else if (meioPagamentoId === 3) {
    const valRecurso = Math.round((valFinalCentavos * percentual30) / 100);
    const restante = valFinalCentavos - valRecurso;

    const financiamento70 = Math.round((restante * percentual70) / 100);
    const financiamento30 = restante - financiamento70;

    parcelas.push(
      criarParcela({
        id: 0,
        meioPagId: 1,
        descricao: 'Recurso Próprio',
        percentual: 30,
        valorCentavos: valRecurso,
        observacao: '',
      }),
      criarParcela({
        id: 1,
        meioPagId: 2,
        descricao: 'Financiamento',
        percentual: 70,
        valorCentavos: financiamento70,
        observacao: 'Compra de Materiais e Início de Montagem',
      }),
      criarParcela({
        id: 2,
        meioPagId: 2,
        descricao: 'Financiamento',
        percentual: 30,
        valorCentavos: financiamento30,
        observacao: 'Entrega do Equipamento',
      }),
    );
  } else if (meioPagamentoId === 4) {
    const valor20 = Math.round((valFinalCentavos * percentual20) / 100);
    const valor30 = Math.round((valFinalCentavos * percentual30) / 100);
    const valor40 = Math.round((valFinalCentavos * percentual40) / 100);
    const valor70 = Math.round((valFinalCentavos * percentual70) / 100);

    parcelas.push(
      // recurso próprio
      criarParcela({
        id: 0,
        meioPagId: 1,
        descricao: 'Recurso Próprio',
        percentual: 40,
        valorCentavos: valor40,
        observacao: 'Sinal',
      }),
      criarParcela({
        id: 1,
        meioPagId: 1,
        descricao: 'Recurso Próprio',
        percentual: 40,
        valorCentavos: valor40,
        observacao: 'Contra Embarque',
      }),
      criarParcela({
        id: 2,
        meioPagId: 1,
        descricao: 'Recurso Próprio',
        percentual: 20,
        valorCentavos: valor20,
        observacao: 'Final da Montagem',
      }),

      // financiamento
      criarParcela({
        id: 3,
        meioPagId: 2,
        descricao: 'Financiamento',
        percentual: 70,
        valorCentavos: valor70,
        observacao: 'Compra de Materiais e Início de Montagem',
      }),
      criarParcela({
        id: 4,
        meioPagId: 2,
        descricao: 'Financiamento',
        percentual: 30,
        valorCentavos: valor30,
        observacao: 'Entrega do Equipamento',
      }),
    );
  }

  return parcelas;
}
